// This component is responsible for the actual routing
import {createBrowserRouter, Outlet} from 'react-router';
// import HeaderOrganism from "../components/header/Header";
// import useSubscribeAccounts from "../hooks/useSubscribeAccounts";
import {Paper} from '@mui/material';
import {Maybe, UserAccount} from '../__generated__/resolvers-types';
import {getAllFeatures} from '../features';
import FeatureDashboard from '../pages/featureDashboard/FeatureDashboard';
import ErrorPage from '../pages/other/ErrorPage';
import LinkGoogleDriveCallbackPage from '../pages/other/LinkGoogleDriveCallbackPage';
import LoginPage from '../pages/other/LoginPage';
import {getAllSettings} from '../pages/settings';
import AppLayout from '../router/AppLayout';
import BranchRoute from '../router/BranchRoute';

export function buildRoute(user?: Maybe<UserAccount>) {
  const featureRoutes = getAllFeatures();
  const settingsRoutes = getAllSettings();
  return createBrowserRouter([
    {
      element: (
        <AppLayout user={user}>
          <Outlet />
        </AppLayout>
      ),
      errorElement: (
        <AppLayout user={user}>
          <ErrorPage />
        </AppLayout>
      ),
      loader: () => ({}),
      children: [
        // internal routes
        {
          element: (
            <BranchRoute user={user} userUndefinedLoading privateRoute={<Outlet />} publicRoute={<LoginPage />} />
          ),
          loader: () => ({}),
          children: [
            ...featureRoutes.flatMap((feature) => {
              if (feature.childRoutes?.length) {
                return [
                  {
                    path: feature.path,
                    element: (
                      <Paper elevation={3} sx={{p: 2}}>
                        <Outlet />
                      </Paper>
                    ),
                    children: [
                      {index: true, element: feature.component(user)},
                      ...feature.childRoutes.map((cr) => ({
                        path: cr.path,
                        element: cr.component(user),
                      })),
                    ],
                  },
                ];
              }
              return [
                {
                  path: feature.path,
                  element: (
                    <Paper elevation={3} sx={{p: 2}}>
                      {feature.component(user)}
                    </Paper>
                  ),
                },
              ];
            }),
            ...settingsRoutes.map((setting) => ({
              path: setting.path,
              element: (
                <Paper elevation={3} sx={{p: 2}}>
                  {setting.component(user)}
                </Paper>
              ),
            })),
            {
              path: 'linkGoogleDriveCallback',
              element: <LinkGoogleDriveCallbackPage />,
            },
          ],
        },
        // landing page - redirect to app dashboard if authenticated, otherwise show not authenticated page
        {
          path: '/',
          loader: () => ({}),
          element: (
            <BranchRoute user={user} privateRoute={<FeatureDashboard user={user} />} publicRoute={<LoginPage />} />
          ),
        },

        {
          path: '*',
          element: <LoginPage />,
        },
      ],
    },
  ]);
}
